import React from "react";

/** Inline validation message below a field (react-hook-form). */
export function FieldError({
  id,
  message,
}: {
  id?: string;
  message?: string | undefined;
}) {
  if (!message) return null;
  return (
    <p
      id={id}
      role="alert"
      className="mt-1.5 text-sm text-red-600 dark:text-red-400"
    >
      {message}
    </p>
  );
}

export function OptionalHint() {
  return (
    <span className="ml-1.5 text-xs font-normal text-slate-500 dark:text-slate-400">
      (optional)
    </span>
  );
}
